import { render, staticRenderFns } from "./price_modifiers.vue?vue&type=template&id=2b93bb8a"
import script from "./price_modifiers.vue?vue&type=script&lang=js"
export * from "./price_modifiers.vue?vue&type=script&lang=js"
import style0 from "./price_modifiers.vue?vue&type=style&index=0&id=2b93bb8a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports